var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }, [
                !_vm.hasCreatedRemittance && _vm.numOfScrAnswers > 1
                  ? _c(
                      "div",
                      { staticClass: "card dashboard-card" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-primary btn-block btn-sm",
                            attrs: { to: "/createremittance" }
                          },
                          [
                            _vm._v(
                              "\n            Skapa remiss på nytt\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix--min" }),
                        _vm._v(" "),
                        _vm._m(1)
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                !_vm.hasCreatedRemittance
                  ? _c("div", [
                      _c("div", { staticClass: "header-wrapper" }, [
                        _c("h2", {
                          staticClass: "text-primary-fh h2--size",
                          domProps: {
                            innerHTML: _vm._s(_vm.data.dashboard.welcomeHeader)
                          }
                        }),
                        _vm._v(" "),
                        _c("h2", { staticClass: "text-primary-fh h2--size" }, [
                          _vm._v(_vm._s(_vm.toTitleCase(_vm.fullname)) + "!")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.data.dashboard.welcomeText)
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance && !_vm.hasTakenBloodTest
                  ? _c("div", [
                      _c("div", { staticClass: "header-wrapper" }, [
                        _c("h2", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.welcomeremittanceheader
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.dashboard.welcomeremittancetext
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasTakenGenTest &&
                _vm.hasDiagnosis && _vm.diagnosisData.fhDiagnosisValue === 2
                  ? _c("div", [
                      _c("div", { staticClass: "header-wrapper" }, [
                        _c("h2", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.welcomegenresultsHeader
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.dashboard.welcomegenresultsPositiveText
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasTakenGenTest &&
                _vm.hasDiagnosis && _vm.diagnosisData.fhDiagnosisValue === 4
                  ? _c("div", [
                      _c("div", { staticClass: "header-wrapper" }, [
                        _c("h2", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.welcomegenresultsHeader
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.dashboard.welcomegenresultsNegativeText
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasDiagnosis
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _c("p", { staticClass: "text-dark" }, [
                        _c("strong", [_vm._v("Från vårdgivaren")]),
                        _vm._v(":\n            "),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diagnosisData.patientText ||
                                "Här kommer meddelande från din vårdgivare att visas"
                            ) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.ifRegionIsSkane &&
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasTakenGenTest &&
                _vm.hasDiagnosis &&
                  (_vm.diagnosisData.fhDiagnosisValue === 1 ||
                    _vm.diagnosisData.fhDiagnosisValue === 2)
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.referralToRegionCreated,
                              expression: "!referralToRegionCreated"
                            }
                          ],
                          staticClass: "card dashboard-card"
                        },
                        [
                          _c(
                            "h5",
                            { staticClass: "text-primary-fh left-header" },
                            [_vm._v("Ta kontakt med en läkare")]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Välj i listan vilket vårdställe som passar dig bäst."
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.careCenter,
                                  expression: "careCenter"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.careCenter = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { domProps: { value: 0 } }, [
                                _vm._v("Ange vårdställe")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.data.misc.facilitylist, function(
                                region,
                                center
                              ) {
                                return _c(
                                  "option",
                                  { key: center, domProps: { value: center } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(center) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "text-primary-fh text-center" },
                            [
                              _vm._v(
                                "..eller skriv i fritext. Var noga med stavningen."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.careFacility,
                                expression: "careFacility"
                              }
                            ],
                            staticClass: "form-control form-control-lg",
                            attrs: {
                              type: "text",
                              placeholder: "Exempelvis: Huddinge vårdcentral"
                            },
                            domProps: { value: _vm.careFacility },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.careFacility = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btn-block create-remittance-btn",
                              attrs: {
                                disabled:
                                  _vm.careCenter === 0 &&
                                  _vm.careFacility.length === 0
                              },
                              on: {
                                click: function($event) {
                                  return _vm.referralToRegion()
                                }
                              }
                            },
                            [_vm._v("\n            Skapa remiss\n            ")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.referralToRegionCreated,
                              expression: "referralToRegionCreated"
                            }
                          ],
                          staticClass: "card dashboard-card bg-light"
                        },
                        [
                          _c("h5", { staticClass: "text-dark left-header" }, [
                            _vm._v("Kallelse skickas med post")
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "text-dark",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.dashboard.referralToRegionText
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-dark" }, [
                            _vm._v(
                              "\n                Du kommer att få en kallelse med brev från " +
                                _vm._s(
                                  _vm.careCenter ||
                                    _vm.careFacility ||
                                    " din valda mottagning"
                                ) +
                                ".\n              "
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.ifRegionIsSkane &&
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasTakenGenTest &&
                _vm.hasDiagnosis &&
                  (_vm.diagnosisData.fhDiagnosisValue === 1 ||
                    _vm.diagnosisData.fhDiagnosisValue === 2)
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "card dashboard-card bg-light" },
                        [
                          _c("p", {
                            staticClass: "text-dark",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.dashboard.referralToRegionSkaneText
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-logo",
                            attrs: {
                              src: require("../assets/img/regioner/SE162321000255/header.svg"),
                              alt: "Header för Region Skåne"
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _vm.hasCreatedRemittance && !_vm.hasTakenBloodTest
                  ? _c("div", { staticClass: "card dashboard-card pulse" }, [
                      _c("h5", { staticClass: "text-primary-fh left-header" }, [
                        _vm._v("Lista provtagningsställen")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Karolinska samt Unilabs har provtagningsställen, klicka nedan på en av länkarna för en komplett lista."
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                !_vm.hasTakenGenTest
                  ? _c("div", [
                      _c("div", { staticClass: "card dashboard-card" }, [
                        _c(
                          "h5",
                          { staticClass: "text-primary-fh left-header" },
                          [_vm._v("Provsvar")]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.labresultsCardText
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getTestDate(_vm.bloodtestData)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "ul-list list-group list-group-flush bg-transparent"
                          },
                          [
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Totalkolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.totalKolesterol
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .totalKolesterolUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Triglycerider "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.triglycerider
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .triglyceriderUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                HDL kolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.bloodtestData.hdl) +
                                            " " +
                                            _vm._s(_vm.bloodtestData.hdlUnit) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                LDL kolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.bloodtestData.ldl) +
                                            " " +
                                            _vm._s(_vm.bloodtestData.ldlUnit) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Lipoprotein (a) "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.lipoProteinA
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.bloodtestData.lipoProteinAUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "ul-list list-group list-group-flush bg-transparent"
                          },
                          [
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.referenceIntervalText
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                Totalkolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .totalKolesterolReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                Triglycerider\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .triglyceriderReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                HDL kolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .hdlReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                LDL kolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .ldlReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.assessmentData &&
                      _vm.assessmentData.bloodSampleAssessmentValue !== 0
                        ? _c("div", { staticClass: "card dashboard-card" }, [
                            _c("p", { staticClass: "text-dark" }, [
                              _c("strong", [_vm._v("Från vårdgivaren")]),
                              _vm._v(":\n              "),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.assessmentData.patientText ||
                                      "Här kommer meddelande från din vårdgivare att visas"
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _vm.assessmentData &&
                      _vm.assessmentData.bloodSampleAssessmentValue === 4
                        ? _c("div", { staticClass: "card dashboard-card" }, [
                            _c("h5", {
                              staticClass: "text-primary-fh left-header",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.genTestSamplingHeader
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.genTestSamplingText
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card dashboard-card" }, [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.sampleEquipmentText
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(4)
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance &&
                _vm.hasTakenBloodTest &&
                _vm.hasTakenGenTest &&
                _vm.hasDiagnosis &&
                  (_vm.diagnosisData.fhDiagnosisValue === 2 ||
                    _vm.diagnosisData.fhDiagnosisValue === 4)
                  ? _c("div", [
                      _c("div", { staticClass: "card dashboard-card" }, [
                        _c(
                          "h5",
                          { staticClass: "text-primary-fh left-header" },
                          [_vm._v("Resultat av ditt gentest")]
                        ),
                        _vm._v(" "),
                        _vm.gentestData.mutation
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.genTestMutationPositiveText
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.gentestData.mutation
                          ? _c("p", [_vm._v(_vm._s(_vm.gentestData.mutation))])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.gentestData.mutation
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.genTestMutationNegativeText
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(5)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card dashboard-card" }, [
                        _c(
                          "h5",
                          { staticClass: "text-primary-fh left-header" },
                          [_vm._v("Provsvar")]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.labresultsCardText
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.assessmentData &&
                        _vm.assessmentData.bloodSampleAssessmentValue !== 0
                          ? _c("div", { staticClass: "card dashboard-card" }, [
                              _c("p", { staticClass: "text-dark" }, [
                                _c("strong", [_vm._v("Från vårdgivaren")]),
                                _vm._v(":\n                "),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.assessmentData.patientText ||
                                        "Här kommer meddelande från din vårdgivare att visas"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(_vm.getTestDate(_vm.bloodtestData)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "ul-list list-group list-group-flush bg-transparent"
                          },
                          [
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Totalkolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.totalKolesterol
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .totalKolesterolUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Triglycerider "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.triglycerider
                                            ) +
                                            "  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .triglyceriderUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                HDL kolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.bloodtestData.hdl) +
                                            " " +
                                            _vm._s(_vm.bloodtestData.hdlUnit) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                LDL kolesterol "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.bloodtestData.ldl) +
                                            "\n                  " +
                                            _vm._s(_vm.bloodtestData.ldlUnit) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v("\n                Lipoprotein (a) "),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData.lipoProteinA
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.bloodtestData.lipoProteinAUnit
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "ul-list list-group list-group-flush bg-transparent"
                          },
                          [
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.dashboard.referenceIntervalText
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                Totalkolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .totalKolesterolReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                Triglycerider\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .triglyceriderReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                HDL kolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .hdlReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "list-group-item bg-transparent" },
                              [
                                _vm._v(
                                  "\n                LDL kolesterol\n                "
                                ),
                                _vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.bloodtestData
                                                .ldlReferenceInterval
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.bloodtestData
                                  ? _c(
                                      "span",
                                      { staticClass: "lab-results-values" },
                                      [_vm._v("-")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.hasCreatedRemittance
                  ? _c(
                      "div",
                      { staticClass: "card dashboard-card" },
                      [
                        _c("h5", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.remittanceHeader
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Här kan du skapa en remiss till provtagning av:"
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-primary btn-block btn-lg",
                            attrs: { to: "/screeningmed" }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.data.dashboard
                                    .startscreeningandremittancebtn
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance && _vm.hasTakenBloodTest
                  ? _c(
                      "div",
                      { staticClass: "card dashboard-card no-border" },
                      [
                        _c("h5", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.samplesdoneheader
                            )
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasCreatedRemittance
                  ? _c(
                      "div",
                      { staticClass: "card dashboard-card no-border" },
                      [
                        _c("h5", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.remittancedoneheader
                            )
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "card dashboard-card no-border" }, [
                  _c("h5", {
                    staticClass: "text-primary-fh left-header",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.dashboard.kinshipHeader)
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.hasCreatedRemittance
                  ? _c(
                      "div",
                      { staticClass: "card dashboard-card no-border" },
                      [
                        _c("h5", {
                          staticClass:
                            "font-weight-bold text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.dashboard.doneLogOutHeader
                            )
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h4", { staticClass: "text-primary-fh" }, [
        _vm._v("Saknas din remiss?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v("\n            Finns inte knappen "),
      _c("b", [_vm._v("Till frågor och remisskapande")]),
      _vm._v(
        " nedanför på denna sida så kan du använda ovanstående.\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "text-primary-fh left-header",
        attrs: {
          href:
            "https://www.karolinska.se/for-patienter/karolinska-universitetslaboratoriet/alla-provtagningsenheter-a-o/",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("@/assets/img/external-link.svg?data"),
            alt: "Ikon för extern länk"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(" Provtagningsställen (Karolinska)")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "text-primary-fh left-header samplepoints-link",
        attrs: {
          href:
            "https://unilabs.se/privatperson/laboratorie-medicin/provtagning",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("@/assets/img/external-link.svg?data"),
            alt: "Ikon för extern länk"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(" Provtagningsställen (Unilabs)")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "text-primary-fh left-header samplepoints-link",
        attrs: {
          href:
            "https://unilabs.se/privatperson/laboratorie-medicin/provtagning",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("@/assets/img/external-link.svg?data"),
            alt: "Ikon för extern länk"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(" Provtagningsställen (Unilabs)")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "text-primary-fh left-header samplepoints-link",
        attrs: {
          href:
            "https://www.karolinska.se/for-vardgivare/karolinska-universitetslaboratoriet/klinisk-genetik/",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("@/assets/img/external-link.svg?data"),
            alt: "Ikon för extern länk"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(" Läs mer om genmutationer")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ul-list" }, [
      _c("li", [_vm._v("Totalkolesterol")]),
      _vm._v(" "),
      _c("li", [_vm._v("Triglycerider")]),
      _vm._v(" "),
      _c("li", [_vm._v("HDL kolesterol")]),
      _vm._v(" "),
      _c("li", [_vm._v("LDL kolesterol")]),
      _vm._v(" "),
      _c("li", [_vm._v("Lipoprotein (a)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 